import React from "react";
import { useAuth } from "../../providers/AuthenticationProvider";
import { HeaderUserDropdown } from "./components/HeaderUserDropdown";
import pathianLogo from "../../assets/PathianLogo.png";
import "./Header.css";

const contentStyle = {
  display: "flex",
  flexDirection: "row",
  justifyContent: "space-between",
  alignItems: "center",
  width: "100%",
  height: "var(--header-height)",
  position: 'fixed',
  top: 0,
  zIndex: '3',
  padding: '12px 15px',
  backgroundColor: 'white',
  borderBottom: 'var(--border-subtle)'
};

const logoStyle = {
  marginLeft: '10px',
  height: '65%'
};

// const searchBarStyle = {
//   width: "22%",
//   margin: "8px",
//   marginTop: "16px",
//   marginBottom: "16px",
//   border: "1px solid #707070",
//   borderRadius: "6px",
//   placeholder: "Search...",
//   fontSize: "16px",
// };

export const Header = () => {
  const { email, distributor } = useAuth();

  return (
    <div style={contentStyle}>
      <img
        src={distributor?.logoUrl ?? pathianLogo}
        alt={distributor?.name ? distributor?.name + " logo" : "Pathian Logo"}
        id="Logo"
        style={logoStyle}
      />

      {/* <input
        type="text"
        className="searchBar"
        placeholder={"Search..."}
        style={searchBarStyle}
      /> */}

      <HeaderUserDropdown username={email} />
    </div>
  );
};
